import type { CmsFleetCategory } from '@/services/cms-sdk';

function isCarouselImage(item: Exclude<CmsFleetCategory['gallery'], undefined>[0]) {
    return Boolean(item.carousel) && Boolean(item.original) && item.type?.toLowerCase() === 'image';
}
export function mapFleetCategoryCarouselImages(fleetCategory?: CmsFleetCategory) {
    if (!fleetCategory) {
        return [];
    }
    const seen = new Set<string>();
    const images: { src: string; alt: string }[] = [];

    if (fleetCategory.scenicImage) {
        seen.add(fleetCategory.scenicImage);
        images.push({
            src: fleetCategory.scenicImage,
            alt: fleetCategory.name,
        });
    }

    for (const item of fleetCategory.gallery ?? []) {
        if (!isCarouselImage(item) || seen.has(item.original)) {
            continue;
        }
        images.push({
            src: item.original,
            alt: item.originalAlt || fleetCategory.name,
        });
        seen.add(item.original);
    }
    return images;
}
